export default {
    API_ENDPOINT: process.env.REACT_APP_API_ENDPOINT || 'http://localhost:8000/api',
    TOKEN_KEY: process.env.REACT_APP_GAME_TOKEN || 'false token',
    PLAYER_DATA: 'game-storage',
    CHAR_DATA: 'current-char',
    PROGRESS_DATA: 'current-progress'
  }
  